<fieldset>
<!--		<div class="row text-center d-flex justify-content-center ml-5">
				<h6 class="col-1">
				</h6>
				<h6 class="col">
					{{"LIABILITIES.QUESTION5.LIABILITY_TYPE"|translate}}
				</h6>
				<h6 class="col">
					{{"LIABILITIES.QUESTION5.LIABILITY_BALANCE"|translate}}
				</h6>
				<h6 class="col">
					{{"LIABILITIES.QUESTION5.MONTHLY_REFUND"|translate}}
				</h6>
				<h6 class="col">
					{{"LIABILITIES.QUESTION5.LIABILITIES_END_DATE"|translate}}
				</h6>
		</div> -->
		<br>
		<app-add-liability class="d-flex justify-content-center text-center"
			*ngFor="let liability of liabilitiesArray.controls; let i=index"
			[index]="i" 
			[liability]="liability"
			(removed)="liabilitiesArray.removeAt($event)"
			[qID]="qID"
			[displayErrors]="displayErrors"
			[types] = "types"
			[displayX]="liabilitiesArray.length>1 && !liability.get('required').value">
	</app-add-liability>
	</fieldset>
	<div class="justify-content-lg-start  justify-content-sm-center">
			<div  *ngIf="liabilitiesArray.length > 0 && liabilitiesArray.length<2 "  class="m-add-line-btn" (click)="addLiability()" role="button" tabindex="0" (keypress)="simulateClick($event)">
					<span>{{"LIABILITIES.QUESTION5.BUTTON_ADD_AND_SAVE"|translate}}</span>
				</div>
			<div *ngIf="liabilitiesArray.length === 0"  class="m-add-line-btn" (click)="addLiability()" role="button" tabindex="0" (keypress)="simulateClick($event)"vvvvv>
				<i class="fa fa-plus" aria-hidden="true"></i>
				<span>{{"LIABILITIES.QUESTION5.BUTTON_ADD"|translate}}</span>
			</div>
	</div>
	<br/>


// WEBPACK FOOTER //
// ./src/app/liabilities-array/liabilities-array.component.html